import { cn } from "../lib/utils";

export function GlassCard({ className, children, ...props }) {
  return (
    <div
      className={cn(
        "relative rounded-2xl border border-white/10 bg-white/[0.04]",
        "backdrop-blur-xl shadow-[0_24px_60px_-30px_rgba(212,175,55,0.25)]",
        "before:pointer-events-none before:absolute before:inset-0 before:rounded-2xl",
        "before:bg-gradient-to-b before:from-white/[0.06] before:to-transparent before:opacity-60",
        className,
      )}
      {...props}
    >
      <div className="relative">{children}</div>
    </div>
  );
}

export default GlassCard;
